module.exports = __webpack_public_path__ + "img/doc_brief_img06.e1cd6ae7.png";